// NewAssistance.js

import React, { useEffect, useState } from "react";
import { GptMessage, MyMessage, TypingLoader, TextMessageBox } from "./index";
import { createThreadUseCase, postQuestionUseCase } from "../../api";
import { useAuth } from "../../hooks";

export function NewAssistance({ assistantId, avatarImg }) {
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [threadId, setThreadId] = useState(null);
  const { accessToken } = useAuth();

  // Efecto para crear el hilo una sola vez
  useEffect(() => {
    const initializeThread = async () => {
      if (assistantId && accessToken) {
        try {
          const newThreadId = await createThreadUseCase(
            accessToken,
            assistantId,
          );
          setThreadId(newThreadId);

          // Añadimos el mensaje de bienvenida después de crear el hilo
          setMessages([
            {
              text: "Saludos, soy tu asistente de Educa360. ¿En qué puedo ayudarte?",
              isGpt: true,
              key: "initial-greeting",
            },
          ]);
        } catch (error) {
          console.error("Error al crear el hilo de conversación:", error);
          setMessages([
            {
              text: "No se pudo iniciar la conversación. Por favor, recarga la página.",
              isGpt: true,
              key: "error-greeting",
            },
          ]);
        }
      }
    };
    initializeThread();
  }, [assistantId, accessToken]); // Dependencias correctas

  const handlePost = async (text) => {
    if (!threadId) return;

    setIsLoading(true);
    setMessages((prev) => [...prev, { text, isGpt: false }]);

    try {
      // 'response' ahora será el objeto completo: { message: "...", messages: [...] }
      const response = await postQuestionUseCase(
        accessToken,
        threadId,
        text,
        assistantId,
      );
      setIsLoading(false);

      // Extraemos el array de la propiedad 'messages' de forma segura
      const messagesArray = response?.messages;

      // Verificamos que sea un array
      if (Array.isArray(messagesArray)) {
        const lastAssistantReply = messagesArray.findLast(
          (message) => message.role === "assistant",
        );

        if (
          lastAssistantReply &&
          Array.isArray(lastAssistantReply.content) &&
          lastAssistantReply.content.length > 0
        ) {
          const messageText =
            lastAssistantReply.content[lastAssistantReply.content.length - 1];
          setMessages((prev) => [...prev, { text: messageText, isGpt: true }]);
        }
      } else {
        console.error("Respuesta de API inesperada:", response);
        setMessages((prev) => [
          ...prev,
          {
            text: "Ha ocurrido un problema al procesar la respuesta.",
            isGpt: true,
          },
        ]);
      }
    } catch (error) {
      console.error("Error al enviar la pregunta:", error);
      setIsLoading(false);
      setMessages((prev) => [
        ...prev,
        {
          text: "No se pudo conectar con el asistente. Inténtalo de nuevo.",
          isGpt: true,
        },
      ]);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-messages">
        <div className="grid grid-cols-12 gap-y-2">
          {messages.map((message, index) =>
            message.isGpt ? (
              <GptMessage
                key={message.key || index}
                text={message.text}
                imageAvatar={avatarImg}
              />
            ) : (
              <MyMessage key={index} text={message.text} />
            ),
          )}
          {isLoading && (
            <div className="col-start-1 col-end-12 fade-in">
              <TypingLoader />
            </div>
          )}
        </div>
      </div>
      <TextMessageBox
        onSendMessage={handlePost}
        placeholder="Escribe aquí lo que deseas"
        disableCorrections
      />
    </div>
  );
}
